import { IPaymentPrice } from '@raskrask-dk/bookingflow-state-machine/'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

const initialState: { paymentInfo?: IPaymentPrice } = {}

export const checkoutSettingsSlice = createSlice({
    name: 'checkoutSettings',
    initialState,
    reducers: {
        setPaymentInfo: (state, action: PayloadAction<IPaymentPrice>) => {
            state.paymentInfo = action.payload
        },
    },
})

export const { setPaymentInfo } = checkoutSettingsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getPaymentInfo = (state: RootState): IPaymentPrice | undefined =>
    state.checkoutSettings.paymentInfo
export default checkoutSettingsSlice.reducer
